import React from 'react';
import ScrollLock from '@atlassian/jira-portfolio-3-common/src/scroll-lock/index.tsx';
import { useIsDragging } from '@atlassian/jira-portfolio-3-issue-drag-and-drop/src/controller/hooks.tsx';

export const DragScrollLock = () => {
	const isDragging = useIsDragging();

	return <ScrollLock axis="horizontal" enabled={isDragging} />;
};
